import {
  getOrganisationAnalytics as getAnalytics,
  getAtRiskLearners as apiGetAtRiskLearners,
  getActiveUsers as apiGetActiveUsers,
  ActiveUsersWindow,
  AnalyticsRange,
} from "../api/analyticsApi";
import { AnalyticsData, AtRiskLearner, ActiveUser } from "../types/types";

/**
 * Get organization analytics data
 * @param organisationId - Organization ID
 * @returns Promise<OrganisationAnalytics>
 */
export async function getOrganisationAnalytics(
  organisationId: string,
  options?: {
    range?: AnalyticsRange;
    startDate?: string;
    endDate?: string;
  }
): Promise<AnalyticsData> {
  try {
    const response = await getAnalytics(organisationId, options);
    return response;
  } catch (error) {
    console.error("Error fetching organisation analytics:", error);
    throw error;
  }
}

export async function getAtRiskLearners(
  organisationId: string,
  windowDays?: number
): Promise<AtRiskLearner[]> {
  try {
    return await apiGetAtRiskLearners(organisationId, windowDays);
  } catch (error) {
    console.error("Error fetching at-risk learners:", error);
    throw error;
  }
}

export async function getActiveUsers(
  organisationId: string,
  window: ActiveUsersWindow = "dau"
): Promise<ActiveUser[]> {
  try {
    return await apiGetActiveUsers(organisationId, window);
  } catch (error) {
    console.error("Error fetching active users:", error);
    throw error;
  }
}
